import { h } from 'preact';
import {
  CompanionPluginOptions,
  getAllowedHosts,
  Provider,
  tokenStorage
} from '@uppy/companion-client';
import Uppy, {
  Meta,
  Body,
  UIPlugin,
  UnknownProviderPlugin,
  UnknownProviderPluginState,
  AsyncStore,
  UppyFile
} from '@uppy/core';
import { ProviderViews } from '@uppy/provider-views';
import SharePointSvg from '@assets/icons/sharepoint.svg?url';

export type SharePointOptions = CompanionPluginOptions;

export default class SharePoint<M extends Meta, B extends Body>
  extends UIPlugin<SharePointOptions, M, B, UnknownProviderPluginState>
  implements UnknownProviderPlugin<M, B>
{
  static VERSION = '1.0.0';

  icon: () => h.JSX.Element;

  provider: Provider<M, B>;

  view!: ProviderViews<M, B>;

  storage: AsyncStore;

  files: UppyFile<M, B>[];

  rootFolderId: string | null = null;

  constructor(uppy: Uppy<M, B>, opts: SharePointOptions) {
    super(uppy, opts);
    this.type = 'acquirer';
    this.icon = () =>
      h('img', {
        src: SharePointSvg,
        alt: '',
        width: 16,
        height: 16
      });
    this.files = [];
    this.storage = this.opts.storage || tokenStorage;
    this.id = this.opts.id || 'SharePoint';

    this.opts.companionAllowedHosts = getAllowedHosts(
      this.opts.companionAllowedHosts,
      this.opts.companionUrl
    );
    this.provider = new Provider(uppy, {
      companionUrl: this.opts.companionUrl,
      companionHeaders: this.opts.companionHeaders,
      companionKeysParams: this.opts.companionKeysParams,
      companionCookiesRule: this.opts.companionCookiesRule,
      provider: 'sharepoint',
      pluginId: this.id,
      supportsRefreshToken: true
    });

    this.title = 'SharePoint';
    this.render = this.render.bind(this);
  }

  install() {
    this.view = new ProviderViews(this, {
      provider: this.provider,
      loadAllFiles: true,
      virtualList: true
    });
    const { target } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }

  uninstall() {
    this.view.tearDown();
    this.unmount();
  }

  render(state: unknown) {
    return this.view.render(state);
  }
}
